import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Tag, ChevronDown, ChevronUp } from "lucide-react";

// Predefined service types for quick selection
const predefinedServiceTypes = [
  "SUMINISTRO E INSTALACIÓN DE VENTANAS Y PUERTAS DE UPVC",
  "SUMINISTRO DE VENTANAS DE ALUMINIO",
  "SUMINISTRO E INSTALACIÓN DE VENTANAS DE ALUMINIO",
  "SUMINISTRO DE VENTANAS Y PUERTAS DE UPVC",
  "SUMINISTRO E INSTALACIÓN DE MAMPARAS DE ALUMINIO",
  "SUMINISTRO DE MAMPARAS Y DIVISIONES DE ALUMINIO",
  "SUMINISTRO E INSTALACIÓN DE FACHADAS DE ALUMINIO"
];

const ServiceTypeSection = ({
  isOpen,
  onOpenChange,
  serviceType,
  setServiceType
}) => {
  return (
    <Collapsible open={isOpen} onOpenChange={onOpenChange}>
      <Card>
        <CollapsibleTrigger asChild>
          <CardHeader className="cursor-pointer hover:bg-slate-50 transition-colors py-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-sm flex items-center gap-2">
                <Tag className="w-4 h-4 text-purple-600" />
                Tipo de Servicio
                <span className="font-normal text-slate-500 text-xs truncate max-w-[300px]">
                  - {serviceType.length > 40 ? serviceType.substring(0, 40) + '...' : serviceType}
                </span>
              </CardTitle>
              {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="pt-0 space-y-3">
            <p className="text-xs text-slate-500">
              Este texto aparecerá en el encabezado de la primera página del PDF impreso
            </p>
            <div className="space-y-2">
              <Label className="text-xs">Descripción del servicio</Label>
              <Input
                value={serviceType}
                onChange={(e) => setServiceType(e.target.value.toUpperCase())}
                placeholder="SUMINISTRO E INSTALACIÓN DE..."
                className="h-9 font-medium text-sm"
                data-testid="service-type-input"
              />
            </div>
            <div>
              <Label className="text-xs text-slate-500">Opciones predefinidas:</Label>
              <div className="flex flex-wrap gap-1.5 mt-1">
                {predefinedServiceTypes.map((type) => (
                  <button
                    key={type}
                    onClick={() => setServiceType(type)}
                    className={`px-2 py-1 text-xs rounded-md border transition-colors ${
                      serviceType === type 
                        ? 'bg-purple-100 border-purple-300 text-purple-700' 
                        : 'bg-slate-50 border-slate-200 text-slate-600 hover:bg-slate-100'
                    }`}
                  >
                    {type.length > 45 ? type.substring(0, 45) + '...' : type}
                  </button>
                ))}
              </div>
            </div>
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
};

export default ServiceTypeSection;
